module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ../~/aphrodite/no-important.js
// module id = 1858
// module chunks = 2